import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';

const ChapterPageHero = ({ heading, smallHeading, image }) => {
  return (
    <div className="chapter-page-hero">
      <div className="chapter-page-hero__container">
        <div className="chapter-page-hero__content">
          <div className="chapter-page-hero__text-info">
            {smallHeading && (
              <span className="chapter-page-hero__small-heading">
                {smallHeading}
              </span>
            )}
            {heading && (
              <h1 className="chapter-page-hero__heading">{heading}</h1>
            )}
          </div>
          {image && (
            <div className="chapter-page-hero__image-holder">
              <Image
                {...image}
                className="chapter-page-hero__image image_size_chapter-page-hero"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ChapterPageHero.propTypes = {
  heading: PropTypes.string,
  smallHeading: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
};

export default ChapterPageHero;
